import React from 'react';
import { Input as ChakraInput } from '@chakra-ui/react';

const Input = ({ ...rest }) => {
  return (
    <ChakraInput
      bg="white"
      mt={2}
      h="60px"
      _placeholder={{ color: 'gray.700', fontWeight: 400, fontSize: 18 }}
      border="none"
      shadow="sm"
      w={['100%', '30%']}
      {...rest}
    />
  );
};

export default Input;
